import { render } from "./BulkWhitelistedCTA.vue?vue&type=template&id=1b341f82"
import script from "./BulkWhitelistedCTA.vue?vue&type=script&lang=js"
export * from "./BulkWhitelistedCTA.vue?vue&type=script&lang=js"

import "./BulkWhitelistedCTA.vue?vue&type=style&index=0&id=1b341f82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__